<template>
  <CardToolbox>
    <ContactPageheaderStyle>
      <sdPageHeader title="Role Master">
        <template #subTitle> 
          <a-input
            v-model:value="searchValue"
            @change="handleSearch"
            placeholder="Search by Name"
          >
            <template #suffix>
              <sdFeatherIcons type="search" size="16" />
            </template>
          </a-input> 
        </template>
        <template #buttons>
          <a-button
            @click="showModal"
            class="btn-add_new"
            size="default"
            type="primary"
            key="1"
          >
            <a to="#">+ Add New Role</a>
          </a-button>
        </template>
      </sdPageHeader>
    </ContactPageheaderStyle>
  </CardToolbox>

  <Main>
    <a-row :gutter="25">
      <a-col :md="24">
        <sdCards headless>
          <UserTableStyleWrapper>
            <div class="contact-table">
              <TableWrapper class="table-responsive">
                <a-table
                  :dataSource="usersTableData"
                  :columns="usersTableColumns"
                  :pagination="{
                    defaultPageSize: 5,
                    total: usersTableData.length,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }"
                />
              </TableWrapper>
            </div>
          </UserTableStyleWrapper>
        </sdCards>
      </a-col>
      <a-modal
        :type="localState.modalType"
        title="Role Information"
        :visible="localState.visible"
        :footer="null"
        :onCancel="handleCancel"
      >
        <div class="project-modal">
          <AddUser>
            <FormValidationWrap>
              <BasicFormWrapper>
                <a-form
                  name="contact"
                  :rules="rules"
                  :model="addFormState"
                  @finish="handleOk"
                  :layout="addFormState.layout"
                >
                  <a-form-item label="Role Name" name="role_name">
                    <a-input
                      v-model:value="addFormState.role_name"
                      placeholder="Eneter Role Name"
                    />
                  </a-form-item>
                  <a-form-item name="permission" label="Permission">
                    <a-select
                      mode="multiple"
                      :default-value="addFormState.permission"
                      v-model:value="addFormState.permission"
                      name="permission[]"
                      placeholder="Please select permission"
                    >
                      <a-select-option
                        v-for="item in permissionlist"
                        v-bind:key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-button
                    htmlType="submit"
                    size="default"
                    type="primary"
                    key="submit"
                  >
                    Add New User
                  </a-button>
                </a-form>
              </BasicFormWrapper>
            </FormValidationWrap>
          </AddUser>
        </div>
      </a-modal>
      <a-modal
        :type="localState.modalType"
        title="User Edit"
        :visible="localState.editVisible"
        :footer="null"
        :onCancel="handleCancel"
      >
        <div class="project-modal">
          <AddUser>
            <FormValidationWrap>
              <BasicFormWrapper>
                <a-form
                  name="contactEdit"
                  :rules="rules"
                  :model="editFormState"
                  @finish="handleEditOk"
                  :layout="addFormState.layout"
                >
                  <a-form-item label="Role Name" name="role_name">
                    <a-input
                      v-model:value="editFormState.role_name"
                      name="role_name"
                      placeholder="Input Name"
                    />
                  </a-form-item>
                  <a-form-item name="permission" label="Permission">
                    <a-select
                      mode="multiple"
                      :default-value="editFormState.permission"
                      v-model:value="editFormState.permission"
                      name="permission[]"
                      placeholder="Please select permission"
                    >
                      <a-select-option
                        v-for="item in permissionlist"
                        v-bind:key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-button
                    htmlType="submit"
                    size="default"
                    type="primary"
                    key="submit"
                  >
                    Update Role
                  </a-button>
                </a-form>
              </BasicFormWrapper>
            </FormValidationWrap>
          </AddUser>
        </div>
      </a-modal>
    </a-row>
  </Main>
</template>

<script>
import { ContactPageheaderStyle, Action, UserTableStyleWrapper } from "./style";
import {
  Main,
  CardToolbox,
  BasicFormWrapper,
  TableWrapper,
} from "../../../styled";
import { AddUser } from "./userstyle";
import { useStore } from "vuex";
import { computed, reactive, ref, onMounted } from "vue";
import { FormValidationWrap } from "./form/Style";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { message, Notification } from "ant-design-vue";

const RoleListTable = {
  name: "RoleListTable",
  components: {
    Main,
    CardToolbox,
    BasicFormWrapper,
    FormValidationWrap,
    AddUser,
    TableWrapper,
    UserTableStyleWrapper,
    ContactPageheaderStyle,
    Action,
  },
  props: {
    tabledata: Object,
  },

  setup(props, { emit }) {
    const router = useRouter();
    const { push } = useRouter();
    var { state, dispatch } = useStore();
    state.RoleMaster.data = JSON.parse(JSON.stringify(props)).tabledata;
    const users = computed(() => state.RoleMaster.data);
    var tabledata = JSON.parse(JSON.stringify(props)).tabledata;
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    var permissionlist = ref(); //added by anil
    var roledrop = ref();

    var currentuser = JSON.parse(localStorage.getItem("user"));
    // console.log(state.UserMaster.data);
    onMounted(() => {
      getPermissionData();
    });

    const getPermissionData = () => {
      dispatch("getPermissionData").then(
        (response) => {
          permissionlist.value = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
      // axios
      //       .get(API_ENDPOINT + 'api/auth/permission')
      //       .then((response) => {
      //         permissionlist.value = response.data.data;
      //   });
    };

    const getdropdata = () => {
      // console.log(currentuser);
      dispatch("getroledropdata").then(
        (response) => {
          // console.log(response.data);
          roledrop.value = response.data.roledata;
          // console.log(roledrop);
        },
        (error) => {
          console.log(error);
        }
      );
    };

    const addFormState = reactive({
      company_id: currentuser.company_id,
      role_name: "",
      permission: [],
      company: currentuser.c_name, 
      layout: "vertical",
    });
    const editFormState = reactive({
      role_name: "",
      permission: [],
      company: currentuser.c_name,
    });

    const rules = {
      role_name: [
        {
          required: true,
          message: "Please enter Role name",
          trigger: "blur",
        },
      ],
      // permission: [
      //   {
      //     required: true,
      //     message: 'Please select permission',
      //     trigger: 'blur',
      //   },
      // ],
    };

    const localState = reactive({
      selectedRowKeys: 0,
      selectedRows: 0,
      visible: false,
      editVisible: false,
      modalType: "primary",
      url: null,
    });
    const searchValue = ref("");

    const handleSearch = () => {
      var data = {};
      data.serchtext = searchValue.value;
      data.userdata = JSON.parse(JSON.stringify(props)).tabledata;
      dispatch("rolemasterSearchData", data);
    };

    const showModal = () => {
      localState.visible = true;
    };

    const showEditModal = (data) => {
      console.log(data);
      localState.editVisible = true;
      editFormState.role_name = data.role_name;
      editFormState.permission = data.permission;
      editFormState.id = data.id;
    };

    const onCancel = () => {
      localState.visible = false;
      localState.editVisible = false;
      localState.update = {};
    };

    const handleOk = (values) => {
      // console.log(addFormState);
      dispatch("roleAddData", addFormState).then(
        (response) => {
          if (response.status == 200) {
            Notification["success"]({
              message: "Succsess!",
              description: "Role Added.",
            });
            // message.success(response.data.message);
            emit("eventname", "emitest");
            onCancel();
          } else {
            Notification["error"]({
              message: "Error!",
              description: "The role name has already been taken..",
            });
            // message.error('something is wrong!');
            // onCancel();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    const handleEditOk = (values) => {
      const updateUsers = users.value;
      // console.log(editFormState);
      // console.log(updateUsers);
      dispatch("roleUpdateData", editFormState).then(
        (response) => {
          if (response.status == 200) {
            emit("eventname", "emitest");
            Notification["success"]({
              message: "Succsess!",
              description: "Role Updated.",
            });
            // message.success('Role Updated Succsessfully!');
            onCancel();
          } else {
            Notification["error"]({
              message: "Error!",
              description: "The role name has already been taken..",
            });
            // onCancel();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    const handleCancel = () => {
      onCancel();
    };

    const onHandleDelete = (id) => {
      const value = [];
      value.data = users.value.filter((item) => item.id !== id);
      value.role_id = id;
      dispatch("roleDeleteData", value);
      Notification["success"]({
        message: "Succsess!",
        description: "Role Deleted.",
      });
      // message.success('Succsessfully Deleted!');
    };

    var usersTableData = computed(() =>
      state.RoleMaster.data
        .sort((a, b) => {
          return b.time - a.time;
        })
        .map((user) => {
          const { id, role_name, status } = user;
          return {
            key: id,
            id: id,
            position: role_name,
            action: (
              <Action class="table-actions">
                <sdDropdown
                  class="wide-dropdwon"
                  overlay={
                    <>
                      <a onClick={() => showEditModal(user, id)} to="#">
                        <span>Edit</span>
                      </a>
                      <a-popconfirm
                        title="Are you sure delete this role?"
                        ok-text="Yes"
                        cancel-text="No"
                        onConfirm={() => onHandleDelete(id)}
                      >
                        <a href="#">Delete</a>
                      </a-popconfirm>
                    </>
                  }
                  action={["click"]}
                >
                  <a-button class="btn-icon" type="info" to="#" shape="circle">
                    <sdFeatherIcons type="more-vertical" size={16} />
                  </a-button>
                </sdDropdown>
              </Action>
            ),
          };
        })
    );

    const usersTableColumns = [
      {
        title: "Id",
        dataIndex: "id",
        key: "id",
        sorter: (a, b) => a.email.length - b.email.length,
        // sorter: (a, b) => a.username.children[0].children.outerText.length - b.username.children[0].children.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Role name",
        dataIndex: "position",
        key: "position",
        sorter: (a, b) => a.position.length - b.position.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Actions",
        dataIndex: "action",
        key: "action",
        width: "90px",
      },
    ];
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows;
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User", // Column configuration not to be checked
        name: record.name,
      }),
    };

    return {
      rowSelection,
      usersTableColumns,
      usersTableData,
      handleCancel,
      handleEditOk,
      handleOk,
      onCancel,
      showEditModal,
      showModal,
      handleSearch,
      localState,
      users,
      searchValue,
      addFormState,
      rules,
      editFormState,
      roledrop,
      permissionlist,
    };
  },
};

export default RoleListTable;
</script>
 
